import { AnswerActions } from '../ActionTypes';

export const setAnswer = (answer) => ({
    type: AnswerActions.SetAnswer,
    answer
});